<template>
<div>
<div class="mpart1">
  <div class="mpart1-1">
    <div class="mpart1-1Title">

        <img width="88" height="88" src="../assets/img/metalcons.png" alt="">
        <h1 class="mpart1Title">О компании</h1>
    </div>
    <p class="mpart1p">«METALIX» предоставляет полный спектор услуг - от проектирования и производства металлоконструкций до доставки на объекты и монтажа.</p>
  </div>    
</div>
<div class="mpart2">
    <div class="mpart2-0">
        <div class="mpart5left">Производство</div>
        <div class="mpart5leftLine"></div>
    </div>
    <div class="mpart2-1">   
      <div class="mpart2-1Line" style="max-width:120px"></div>
        <p class="mpart2-1p metal-text-first about-text-main">Мы работаем для вашей выгоды, 
комфорта и безопасности</p>  
<hr class="about-line"/> 
    </div>
    <div class="mpart2-2">
        <p class="about-text">Компания «METALIX», располагает большим опытом в плане производства металлических изделий и металлообработки. Одним из профилирующих направлений деятельности нашей компании является изготовление металлоизделий по чертежам заказчика. <br/> <br/>

Всем необходимым оборудованием оснащены все наши промышленные цеха, при помощи которого может быть изготовлена абсолютно любая продукция, которая предназначена для применения в различных сферах промышленного хозяйства.</p>
    </div>
    <div class="mpart2-4">
        <img class="metal-pic decorative-image-2" src="../assets/img/about1.png" alt="">
    </div>
    <div class="mpart2-3 metal-text-second">
      <div class="about-first">
        <img style="margin-top:56px" class="metal-icon" src="../assets/img/about-icon.png" alt="">
        <h4 style="margin-top:3.5rem;">Собственное <br/>
производство</h4>
</div>
         <div class="mpart2-1Line"></div>
        <p class="mpart2-1p about_text">Собственно производство с  профессиональным европейским оборудованием позволяет нам быстро выполнять заказы любого объёма и степени сложности. </p>   

    </div>
     <div class="mpart2-6 metal-text-second">
         <div class="about-second">
           
        <img style="margin-top:56px" class="metal-icon" src="../assets/img/about-icon1.png" alt="">
        <h4 style="margin-left:2rem; margin-top:3.5rem;">Более <br/>
150 сотрудников</h4>
</div>
         <div class="mpart2-1Line"></div>
         <p class="mpart2-1p about_text">В нашей компании работает более 150 сотрудников, слаженно и оперативно осуществляющих все этапы производственного цикла.</p>   
    </div>
    <div class="mpart2-5">
        <img class="metal-pic decorative-image-2" src="../assets/img/about2.png" alt="">
    </div>

     




    <div class="mpart2-8">
        <img class="metal-pic decorative-image-2" src="../assets/img/about3.png" alt="">
    </div>
    <div class="mpart2-7 metal-text-second">
        <div class="about-first">
        <img style="margin-top:56px" class="metal-icon" src="../assets/img/about-icon2.png" alt="">
        <h4 style="margin-top:3.5rem;">Проектный <br/>
департамент</h4>
</div>


         <div class="mpart2-1Line"></div>
        <p class="mpart2-1p about_text">Проектный департамент разботает оригинальные чертежи изделий в соответствии с условиями , целями и пожеланиями.   </p>   

    </div>
    <div class="mpart2-11 metal-text-second">
         <div class="about-second">
             <img style="margin-top:56px; margin-right:3rem" class="metal-icon" src="../assets/about-icon1.svg" alt="">
           <h4 style="margin-top:3.5rem;">На рынке <br/>
 
более 3 лет</h4>
      
        
</div>
         <div class="mpart2-1Line"></div>
         <p class="mpart2-1p about_text"> Мы на рынке более з лет. Благодаря чему у нас богатый опыт в этой сфере, позволяющий решать проблемы любой сложности. </p>   
    </div>
    <div class="mpart2-10">
        <img class="metal-pic decorative-image-2" src="../assets/img/Home/image286.png" alt="">
    </div>
    
</div>




  
    <div class="part11">
      <div class="part11-0"><div class="part11Line"></div></div>
      <div class="part11-1">
        <div class="part11InfoLine"></div>
        <h3 class="part11Info">Новости</h3>
      </div>
      <div class="part11-2">
        <h2 class="part11Title">
          Информационная лента с новостями о деятельности компании.
        </h2>
      </div>
      <div class="part11-3">
        <button class="part11B">Перейти в новостной раздел компании<img style="margin-left:4rem;" src="../assets/vvv.svg"> </button>
      </div>
      <div class="part11-4">
        <div class="part11BlockLine"></div>
        <div class="part11Date">
          <h2 class="part11DateText">17 дек. 2020 г.</h2>
        </div>
        <h1 class="part11BTitle">
          Напротив ЦУМа в Ташкенте построят комплекс «Истиклол»
        </h1>
        <p class="part11BP">
          Столичный хокимият объявил конкурс на создание проекта концепции
          комплекса «Истиклол», посвященного 30-летию независимости Узбекистана.
        </p>
      </div>
      <div class="part11-5">
        <div class="part115Img">
          <img
            class="part11Imargin mainImgc"
            width="240px"
            height="344px"
            src="../assets/img/Group665.png"
            alt=""
          />
        </div>
        <div class="part11BlockLine2"></div>
        <div class="part11Date2">
          <h2 class="part11DateText">17 дек. 2020 г.</h2>
        </div>
        <h1 class="part11BTitle2">
          Фасадное<br />
          освещение зданий
        </h1>
      </div>
      <div class="part11-6">
        <div class="part11BlockLine"></div>
        <div class="part11Date">
          <h2 class="part11DateText">17 дек. 2020 г.</h2>
        </div>
        <h1 class="part11BTitle">
          Собственное <br />
          производство
        </h1>
        <p class="part11BP">
          «METALIX» производит металло конструкции на профессионабльных станках
          европейских брендов, что помогает быстро и эффективно выполнять заказы
          любого объема.
        </p>
      </div>
      <div class="part11-7">
        <div style="position: relative">
          <img
            class="part11Imargin mainImgc"
            width="240px"
            height="344px"
            src="../assets/img/Group666.png"
            alt=""
          />
        </div>
        <div class="part11BlockLine2"></div>
        <div class="part11Date2">
          <h2 class="part11DateText">17 дек. 2020 г.</h2>
        </div>
        <h1 class="part11BTitle2">
          Быстровозводимые<br />
          здания из<br />
          сэндвич-панелей
        </h1>
      </div>
      <div class="part11-8">
        <img
          class="part11Imargin"
          width="240px"
          height="344px"
          src="../assets/img/Group667.png"
          alt=""
        />
        <div class="part11BlockLine2"></div>
        <div class="part11Date2">
          <h2 class="part11DateText">17 дек. 2020 г.</h2>
        </div>
        <h1 class="part11BTitle2">
          Импортное<br />
          металлургическое<br />
          сырье освободили<br />
          от таможенных<br />
          платежей
        </h1>
      </div>
    </div>
       <div class="mpart12" >
    
       <div class="mpart12-0Line"></div>
      <div class="mpart12-1">
        <div class="mpart12-1Line"></div>
      </div>
      <div class="mpart12-2">
        <h4 class="mpart12-2Info">Обратная связь</h4>
        <div class="mpart12-2InfoLine"></div>
      </div>
     <div class="mpart12-3">
        <h1 class="mpart12-3T">
          Заполните форму обратной <br />
          связи и мы оперативно<br />
          свяжемся с вами !
        </h1>
      </div>
  <div class="mpart12-4">
       <b-form @submit="onSubmit" v-if="show" class="row" action="../../public/test.php"  method="POST">
      <b-form-group class="col-md-6 form-metalix">
        <b-form-input class="form-metalix-1" label="name"
          id="input-1"
          v-model="name"
          type="name"
          placeholder="Ваша имя"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group  class="col-md-6 form-metalix">
        <b-form-input class="form-metalix-1" label="surname"
          id="input-2"
          v-model="surname"
          type="surname"
          placeholder="Ваша фамилия"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group class="col-md-6 form-metalix">
        <b-form-input class="form-metalix-1" label="email"
          id="input-3"
          v-model="email"
          type="email"
          placeholder="Ваша почта"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group  class="col-md-6 form-metalix">
        <b-form-input class="form-metalix-1" label="phone"
          id="input-4"
          v-model="phone"
          type="phone"
          placeholder="Ваш номер"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group  class="form-metalix">
        <b-form-input class="form-metalix-1" label="message"
          id="input-5"
          v-model="message"
          type="message"
          placeholder="Комментария"
          
        ></b-form-input>
      </b-form-group>
        <div style="display: flex; width:50%;">
          <input type="checkbox" checked  style="width:30px; height:50px; margin-right:3rem;">
          <p style="color:white;"> Я согласен на обработку<br/>персональных данных.  </p>
         
        </div>

      <b-button data-submit="...Sending" @click="showAlert" class="col-md-6 form-metalix-1 sending-btn" type="submit"  variant="primary">Отправить заявку</b-button>
    </b-form>
      </div>
      <div class="mpart12-5">
        <div class="mpart12TitleLine"></div>
        <p class="mpart12Tp">
          В разделе “комментарий” вы можете указать удобное для вас время когда
          мы можем с вами связаться.
        </p>
      </div>
      <div class="mpart12-6">
        <p class="mpart12Tp2">
          Мы не занимаемся рассылкой рекламных сообщений, а также не передаем
          контактные данные третьим лицам !
        </p>
      </div>
    </div>
    <div class="mpart13">
      <div class="mpart13-0">
        <div class="mpart13-0L"></div>
        <h4 class="mpart13-0T">Контакты</h4>
      </div>
      <!-- <div class="mpart13-1">
        <div class="mpart13-1Line"></div>
      </div> -->
      <div class="mpart13-2">
        <div style="margin-left:0px;" class="part11Line"></div>
        <h1 class="mpart13T">
          Мы благодарны Вам за проявленный интерес к нашей компании.
        </h1>
      </div>
      <div class="mpart13-3">
        <p class="mpart13Tp">
          Вы также можете получить консультацию по интересующим вас вопросам в
          любое время или приехать к нам в офис.
        </p>
      </div>
      <div class="mpart13-4">
        <div class="mpart13-4Line"></div>
        <div class="row about-part">
          <div class="col-sm-12 mpart13AdressInfo">
            <img
            width="24px" height="24px"
              class="mpart13AdresInfoimg"
              src="../assets/img/location.svg"
              alt=""
            />
            <ul class="mpart13-4Address">
              <li>г.Ташкент, Сергели</li>
              <li> ул.Нилуфар 77/7, 100155</li>
            </ul>
          </div>
          <div class="col-sm-12" style="display: flex">
            <img
            width="24px" height="24px"
              class="mpart13AdresInfoimg"
              src="../assets/img/phone.svg"
              alt=""
            />
            <ul class="mpart13-4PhoneUl">
              <li>+998 97 108 4444</li>
              <li>+998 97 109 4444</li>
            </ul>
          </div>
          <div class="col-sm-12" style="display: flex;">
            <img style="margin-top:16px;" width="24px" height="24px" src="../assets/img/mail.svg" alt="" />
            <p class="mpart13-4mailp">info@metalix.uz</p>
          </div>
          <div class="col-sm-12">
            <ul class="mpart13-4PhoneUl2">
              <li>По вопросам партнерства</li>
              <li>+998 90 334 35 00</li>
              <li>info@metalix.uz</li>
            </ul>
          </div>
          <!-- <div class="col-sm-12">
            <div class="socialTag" style="display: flex">
              <img class="part13icon" src="../assets/img/tgb.svg" alt="" />
              <p class="part13-4mailp2">Telegram</p>
            </div>
            <div class="socialn socialTag">
              <img class="part13icon" src="../assets/img/fbb.svg" alt="" />
              <p class="part13-4mailp2">Facebook</p>
            </div>
            <div class="socialn socialTag">
              <img class="part13icon" src="../assets/img/Inb.svg" alt="" />
              <p class="part13-4mailp2">Instagram</p>
            </div>
          </div> -->
        </div>
      </div>
      <div class="mpart13-5">
        <div class="mapouter">
          <div class="gmap_canvas">
          
          <iframe 
            class="gmap_iframe"
             
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2970.6581975340723!2d69.25022158783936!3d41.20638627079112!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x702a9595707bb6f!2zNDHCsDEyJzIyLjkiTiA2OcKwMTUnMDguNyJF!5e0!3m2!1sru!2s!4v1636694271660!5m2!1sru!2s" width="100%" height="886" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
            <!-- <iframe
              class="gmap_iframe"
              width="100%"
              frameborder="0"
              scrolling="no"
              marginheight="0"
              marginwidth="0"
              src="https://maps.google.com/maps?width=1112&amp;height=886&amp;hl=en&amp;q=tashkent&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
              style="padding: 0 auto"
            ></iframe> -->
            <!-- https://goo.gl/maps/BcKh4QETzn99XK7E9 -->
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="mpart13">
      <div class="mpart13-0">
        <h4 class="mpart13-0T">Контакты</h4>
        <div class="mpart13-0L"></div>
      </div>
      <div class="mpart13-1">
        <div class="mpart13-1Line"></div>
      </div>
      <div class="mpart13-2">
        <h1 class="mpart13T">
          Мы благодарны Вам за проявленный <br />интерес к нашей компании.
        </h1>
      </div>
      <div class="mpart13-3">
        <p class="mpart13Tp">
          Вы также можете получить консультацию по интересующим вас вопросам в
          любое время или приехать к нам в офис.
        </p>
      </div>
      <div class="mpart13-4">
        <div class="mpart13-4Line"></div>
        <div style="display: flex; margin-top: 84px">
          <img src="../assets/img/location.svg" alt="" />
          <ul class="mpart13-4Address">
            <li>г.Ташкент, Сергели</li>
            <li>ул.Нилуфар 77/7, 100155</li>
          </ul>
        </div>
        <div style="display: flex">
          <img src="../assets/img/phone.svg" alt="" />
          <ul class="mpart13-4PhoneUl">
             <li>+998 97 108 4444</li>
              <li>+998 97 109 4444</li>
          </ul>
        </div>
        <div style="display: flex; margin-top: 40px">
          <img src="../assets/img/mail.svg" alt="" />
          <p class="mpart13-4mailp">info@metalix.uz</p>
        </div>
        <div>
          <ul class="mpart13-4PhoneUl2">
            <li>По вопросам партнерства</li>
            <li>+998  90 334 35 00</li>
            <li>info@metalix.uz</li>
          </ul>
        </div>
        <div style="display: flex">
          <img class="mpart13icon" src="../assets/img/tgb.svg" alt="" />
          <p class="mpart13-4mailp2">Telegram</p>
        </div>
        <div style="display: flex; margin-top: 16px">
          <img class="mpart13icon" src="../assets/img/fbb.svg" alt="" />
          <p class="mpart13-4mailp2">Facebook</p>
        </div>
        <div style="display: flex; margin-top: 16px">
          <img class="mpart13icon" src="../assets/img/Inb.svg" alt="" />
          <p class="mpart13-4mailp2">Instagram</p>
        </div>
      </div>
      <div class="mpart13-5">
        <div class="mapouter">
          <div class="gmap_canvas">
            <iframe
              class="gmap_iframe"
              width="100%"
              frameborder="0"
              scrolling="no"
              marginheight="0"
              marginwidth="0"
              src="https://maps.google.com/maps?width=1112&amp;height=886&amp;hl=en&amp;q=tashkent&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
            ></iframe>
          </div>
        </div>
      </div>
    </div> -->
   
</div>
</template>
<script>

import { directive } from "vue-awesome-swiper";
import axios from 'axios';
import "swiper/swiper-bundle.css";
export default {
  data() {
      return {
        form: {
          name: '',
          surname: '',
          email: '',
          phone: '',
          message: '',
        },
        // foods: [{ text: 'Select One', value: null }, 'Carrots', 'Beans', 'Tomatoes', 'Corn'],
        show: true,
      }
    },
    methods: {
      onSubmit(event) {
        event.preventDefault()
        let data = new FormData(); 
    
 
    data.append('name', this.name) 
    data.append('surname', this.surname) 
    data.append('email', this.email) 
    data.append('phone', this.phone) 
    data.append('message', this.message)
    console.log(data)
        axios.post('../../public/test.php', data)

    .then((data) => {this.$swal('Отправлено');console.log(data)})
    .catch(error => {

       
        console.error('There was an error!', error);
        this.$swal('Error');
    });
      },
      


      showAlert(){
			
  
 
  
			
		},
    },
   components: {
    // VueSlickCarousel,
    // Carousel, Slide
   
  },
  directives: {
    swiper: directive,
  }, 
}
</script>
<style scoped>
.swiper-button-prev, .swiper-button-next{
  color: white !important;
}





.part11 {
  display: grid;
  grid-template-columns: 200px 1fr 1fr 1fr 1fr 1fr 0.5fr;
  grid-auto-rows: minmax(1136, auto);
  background: #fafafa;
  /* margin-top: 235px; */
}
.part11Line {
  margin-top: 108px;
  margin-left: 202px;
  margin-bottom: 99px;
  width: 120px;
  height: 1px;

  background: #b4c0cf;
}
.part11Info {
  width: 120px;
  height: 24px;

  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* _Text */
  margin-top: -180px;
  margin-left: 40px;
  color: #233b57;

  transform: rotate(-90deg);
}
.part11InfoLine {
  display: inline-block;
  width: 164px;
  height: 2px;
  margin-top: 180px;
  /* _Text */
  margin-left: -5px;
  background: #233b57;
  transform: rotate(-90deg);
}
.part11-1 {
  grid-column: 1/2;
  grid-row: 3/7;
  display: block;
}
.part11-2 {
  grid-column: 2/5;
  grid-row: 2/3;
}
.part11-3 {
  grid-column: 5/7;
  grid-row: 2/3;
}
.part11-4 {
  grid-column: 2/3;
  grid-row: 3/7;
}

.part11-5 {
  grid-column: 3/4;
  grid-row: 3/7;
}
.part11-6 {
  grid-column: 4/5;
  grid-row: 3/7;
}
.part11-7 {
  grid-column: 5/6;
  grid-row: 3/7;
}

.part11-8 {
  grid-column: 6/7;
  grid-row: 3/3;
}
.part11Imargin {
  margin-top: 120px;
}
.part11BP {
  height: 192px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 32px;
  /* or 229% */

  letter-spacing: 0.1em;
  text-indent: 24px;

  /* _Text */

  color: #233b57;
}
.part11BTitle {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  /* or 160% */
  height: 128px;
  letter-spacing: 0.1em;
  text-align: left;
  /* _Text */
  margin-top: 92px;
  margin-bottom: 32px;
  color: #233b57;
}
.part11BTitle2 {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  /* or 160% */
  height: 128px;
  letter-spacing: 0.1em;
  text-align: left;
  /* _Text */
  margin-left: 43px;
  margin-top: 32px;
  margin-bottom: 88px;
  color: #233b57;
}
.part11DateText {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  /* identical to box height, or 171% */

  letter-spacing: 0.05em;

  /* Text */

  color: #233b57;

  opacity: 0.32;

  /* Inside Auto Layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}

.part11Date {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 16px;
  margin-bottom: 32px;

  width: 140px;
  height: 32px;
  background: #ebf2f0;
}
.part11Date2 {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 16px;
  margin-bottom: 32px;

  margin-left: 43px;
  width: 140px;
  height: 32px;
  background: #ebf2f0;
}
.part11B {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 7px;
  line-height: 20px;
  /* identical to box height, or 200% */

  text-align: center;
  letter-spacing: 2px;
  text-transform: uppercase;
  width: 544px;
  color: #233b57;
  height: 64px;
  background: transparent;
  border: 1px solid #233b57;
  box-sizing: border-box;
}
.part11B img{
  margin-left: 2rem !important;
}
.part11BlockLine2 {
  width: 240px;
  height: 2px;
  margin-top: 32px;
  margin-bottom: 23px;
  margin-left: 43px;
  background: #b4c0cf;
  opacity: 0.32;
}
.part11BlockLine {
  width: 240px;
  height: 1px;
  margin-top: 120px;

  margin-bottom: 23px;
  background: #b4c0cf;
  opacity: 0.32;
}
.part11Title {
  height: 196px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  /* or 150% */

  letter-spacing: 0.1em;

  /* _Text */

  color: #233b57;
}


.form-metalix {
  margin-bottom: 5rem;
}
.form-metalix-1{
  height: 80px;
}
.sending-btn{
  width: 400px;
  margin-left: 15px !important;
  background-color: white;
  border: none;
  font-family: Styrene A LC;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #272a2e;
}


.swiper-pagination {
  position: absolute;
  text-align: center;
  transition: 300ms opacity;
  transform: translate3d(0, 0, 0);
  z-index: 10;
  background: #fbfbfb;
  color: black;
  width: 456px;
  height: 120px;
  margin-bottom: -4px;
  margin-left: 0px;
}

.swiper-pagination-fraction {
  /* color: red !important; */
  padding-top: 50px;
  /* border: 1px solid red; */
}
.mpart13AdresInfoimg {
  margin-top: 45px;
  /* width: 40px;
  height: 40px; */
}
.mpart13AdressInfo {
  display: flex;
  margin-top: 84px;
}
.mpart13AdresInfoimg {
  margin-top: 45px;
  /* width: 40px;
  height: 40px; */
}
.mpart1{
   display: grid;
  grid-template-columns: 232px 1fr 384px;
  grid-auto-rows: minmax(472, auto);
   background: #fbfbfb;  
}
.mpart1-1 {
  grid-column: 2/3;
  grid-row: 1/2;
}
.mpart1-1Title{
    display: flex;
    justify-content: left;
    margin-top: 96px;
    margin-left: -2rem;
}
.mpart1Title{
height: 88px;
font-family: Inter;
font-style: normal;
font-weight: bold;
font-size: 64px;
line-height: 88px;
/* identical to box height, or 137% */
margin-left: 64px;
letter-spacing: 0.015em;
text-transform: uppercase;

/* metalix (ligtt,text) */

color: #36454F;
}
.mpart1p{
    height: 80px;
    margin-top: 40px;
    margin-bottom: 3rem;
text-align: left;
font-family: Inter;
font-style: normal;
font-weight: 500;
font-size: 24px;
line-height: 40px;
/* or 167% */
margin-left: -2rem;
letter-spacing: 0.1em;
text-indent: 32px;

/* metalix (ligtt,text) */

color: #36454F;
}
.mpart8Line {
  width: 120px;
  height: 1px;
  margin-left: 232px;
  margin-top: 108px;
  margin-bottom: 99px;
  background: #b4c0cf;
}
.mpart8Margin {
  margin-bottom: 40px;
  margin-top: 40px;
}
.mpart8Title {
  width: 80%;
  height: 96px;
  margin-bottom: 104px;
  margin-left: 32px;
  margin-right: 32px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  /* or 150% */

  letter-spacing: 0.1em;
  text-indent: 32px;

  /* metalix (ligtt,text) */

  color: #36454f;
}
.mpart8mainTitle {
  text-align: left;
  position: fixed;
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 64px;
  line-height: 88px;
  /* or 137% */
  z-index: 5;
  width: 1000px;
  margin-top: -630px;
  margin-left: 152px;

  letter-spacing: 0.015em;
  text-transform: uppercase;

  /* _Text */

  color: #fbfbfb;
}
 .mpart8mainTitlep {
    position: absolute;
    width: 240px;
    height: 168px;
    left: 16px;
    top: 370px;
    z-index: 1;
    color: #fbfbfb !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
  }
  .mpart2-0{
    margin-top: 5rem;
  }
.mpart2
{
    display: grid;
  grid-template-columns: 200px 1fr 1fr 1fr 1fr 1fr 0.5fr;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.mpart2-0 {
  grid-column: 1/2;
  grid-row: 2/2;
}
.mpart2-1 {
  grid-column: 2/4;
  grid-row: 1/2;
  text-align: left;
}
.mpart2-2 {
  grid-column: 5/7;
  grid-row: 1/2;
}
.mpart2-3 {
  grid-column: 2/4;
  grid-row: 2/3;
  margin-top: 32px;
}
.mpart2-4 {
  grid-column: 5/7;
  grid-row: 2/3;
  text-align: left;
  margin-top: 32px;
}
.mpart2-5 {
  grid-column: 2/4;
  grid-row: 3/3;

}
.mpart2-6 {
  grid-column: 5/7;
  grid-row: 3/3;
}

.mpart2-7 {
  grid-column: 2/4;
  grid-row: 4/4;
  margin-top: 32px;
}
.mpart2-8 {
  grid-column: 5/7;
  grid-row: 4/4;
  text-align: left;
  margin-top: 32px;
}
.mpart2-10 {
  grid-column: 2/4;
  grid-row: 5/5;

}
.mpart2-11 {
  grid-column: 5/7;
  grid-row: 5/5;
}
.mpart2-9 {
  grid-column: 4/8;
  grid-row: 6/6;

}
.mpart2-1Line{
    width: 760px;
height: 1px;
margin-top: 64px;
/* line (darck) */
margin-bottom: 6rem;
background: #B4C0CF;
}
.mpart2-1p{
    width: 696px;
    height: 120px;
text-align: left;
font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 18px;
line-height: 40px;
/* or 222% */

letter-spacing: 0.05em;
text-indent: 32px;

/* metalix (ligtt,text) */

color: #36454F;
}
.about-text-main{
  width: 696px;
    height: 120px;
text-align: left;
font-weight: 600 !important;
font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 54px !important;
line-height: 64px;
/* or 222% */

letter-spacing: 0.05em;
text-indent: 32px;

/* metalix (ligtt,text) */

color: #36454F;
}
.mpart5leftLine {
  width: 164px;
  height: 2px;
  margin-top: 180px;
  margin-left: 18px;
  background: #272a2e;
  /* line */

  box-shadow: inset 1px 0px 0px #36454f;
  transform: rotate(-90deg);
}
.mpart5left {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* metalix (ligtt,text) */

  color: #36454f;

  transform: rotate(-90deg);
}

.inputMar {
 margin-left:152px;
  /* margin-right: 36px; */
}
/************part8  ****************/

.mpart8 {
  display: grid;
  grid-template-columns: 200px 2fr 0.5fr 0.5fr 0.5fr;
  grid-auto-rows: minmax(472, auto);
  background: #ffffff;
}
.mpart8-0 {
  grid-column: 2/4;
  grid-row: 1/2;
}
.mpart8-1 {
  grid-column: 1/2;
  grid-row: 3/4;
  display: block;
}

.mpart8-2 {
  grid-column: 2/4;
  grid-row: 2/2;
}

.mpart8-3 {
  grid-column: 4/5;
  grid-row: 2/2;
}

.mpart8-4 {
  grid-column: 5/6;
  grid-row: 2/2;
}

.mpart8-5 {
  grid-column: 2/6;
  grid-row: 3/4;
}
.mpart8InfoLine {
  width: 164px;
  height: 2px;
  right: -151px;
  bottom: -2px;

  /* metalix (ligtt,text) */

  background: #36454f;
  transform: rotate(-90deg);
}
.mpartInfoT {
  width: 78px;
  height: 24px;

  margin-top: 150px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* metalix (ligtt,text) */

  color: #36454f;

  transform: rotate(-90deg);
}
#part8carousel .VueCarousel-navigation-next{
    
    z-index: 4 !important;
    margin-right: 135px !important;
    margin-top: -530px !important;
}
#part8carousel .VueCarousel-navigation-prev{
   
    margin-top: -530px !important;
    margin-left: 1365px !important;
    z-index: 4 !important;
}
/***********part 8 end */
/**************part12 */
.mpart12 {
  display: grid;
  grid-template-columns: 200px 1fr 1fr 1fr 1fr 1fr;
  grid-auto-rows: minmax(1136, auto);
  background: #36454f;
}
.mpart12-0 {
  grid-column: 2/4;
  grid-row: 1/2;
}
.mpart12-1 {
  grid-column: 5/6;
  grid-row: 1/2;
}
.mpart12-2 {
  grid-column: 1/2;
  grid-row: 1/7;
}
.mpart12-3 {
  grid-column: 2/4;
  grid-row: 2/3;
}
.mpart12-4 {
  grid-column: 5/5;
  grid-row: 2/5;
}
.mpart12-5 {
  grid-column: 2/4;
  grid-row: 3/4;
}
.mpart12-6 {
  grid-column: 2/4;
  grid-row: 4/6;
}
.mpart12TitleLine {
  width: 392px;
  height: 4px;
  margin-top: 96px;
  margin-bottom: 76px;
  /* _Light */

  background: #fbfbfb;
}
.mpart12Tp {
  width: 392px;
  height: 96px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 32px;
  /* or 200% */

  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
.mpart12Tp2 {
  width: 392px;
  height: 96px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 32px;
  /* or 200% */
  margin-top: 72px;
  margin-bottom: 104px;
  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
.mpart12-0Line {
  width: 120px;
  height: 2px;
  margin-top: 108px;
  margin-bottom: 99px;
  /* _Light */
  margin-left: 0px;
  background: #fbfbfb;
}
.mpart12-1Line {
  width: 830px;
  height: 2px;

  margin-top: 108px;
  margin-bottom: 99px;
  /* _Light */

  background: #fbfbfb;
  opacity: 0.16;
}
.mpart12-2Info {
  margin-top: 300px;
  width: 207px;
  height: 24px;

  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* line (darck) */

  color: #b4c0cf;

  transform: rotate(-90deg);
}
.mpart12-2InfoLine {
  width: 164px;
  height: 2px;
  margin-top: 190px;
  margin-left: 21px;
  background: #4b5a64;
  /* line */

  box-shadow: inset 1px 0px 0px #36454f;
  transform: rotate(-90deg);
}
.mpart12-3T {
  width: 543px;
  height: 144px;
  margin-top: 0;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  /* or 150% */

  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
.mpart12Checkp {
  width: 310px;
  height: 48px;
  text-align: left;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */
  margin-left: 50px;
  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
#mpart12Check {
  width: 32px;
  height: 32px;
  background-color: #36454f !important;
  /* Light (darck) 02 */

  border: 1px solid #9dafbc;
  box-sizing: border-box;
  border-radius: 1.5px;
}
.mpart12InfoBT {
  font-family: Styrene A LC;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  text-align: center;
  letter-spacing: 2px;
  text-transform: uppercase;

  /* Metalix_darck */

  color: #272a2e;
}
.mpart12InfoLine {
  width: 835px;
  height: 1px;
  margin-bottom: 63px;
  /* _Light */
 margin-left: .8rem;
  background: #fbfbfb;
  opacity: 0.16;
}
.mpart12InfoMust {
  width: 532px;
  height: 24px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  margin-top: 40px;
  margin-bottom: 104px;
  margin-left: 15px;
  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
.mpart12InfoButton {
  width: 392px;
  height: 80px;
  margin-left: 1rem;
  background: #cfd3d6;
  box-shadow: 0px 4px 32px #575d65;
}

.mpart12Infotextarea{
  background: white;
  /* _Light */
  margin-top: 48px;
  margin-left: 0px !important;
  margin-bottom: 46px;
  width: 835px !important;
  height: 80px;
  border: 1px solid #fbfbfb;
  box-sizing: border-box;
  resize: none;
}
#fname {
  width: 392px;
  height: 64px;

  /* _Light */

  background: #fbfbfb;
  /* _Light */

  border: 1px solid #fbfbfb;
  box-sizing: border-box;
}
/****************part12 end*/
/*****part 13 */
.mpart13 {
  display: grid;
  grid-template-columns: 200px 1fr 1fr 1fr 1fr 1fr 0.5fr;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.mpart13-0 {
  grid-column: 1/2;
  grid-row: 3/3;
}
.mpart13-1 {
  grid-column: 2/4;
  grid-row: 1/2;
}
.mpart13-2 {
  grid-column: 2/4;
  grid-row: 2/2;
}
.mpart13-3 {
  grid-column: 5/7;
  grid-row: 2/3;
}
.mpart13-4 {
  grid-column: 2/4;
  grid-row: 3/3;
}
.mpart13-5 {
  grid-column: 4/8;
  grid-row: 3/3;
}
.mpart13-4Line {
  width: 392px;
  height: 4px;

  /* _Text */

  background: #233b57;
}
.mpart13icon {
  margin-top: -15px;
}
.mpart13-4Address {
  width: 336px;
  height: 48px;
  margin-top: 35px;
  text-align: left;
  list-style-type: none;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  letter-spacing: 0.15em;

  /* Text */

  color: #233b57;
}
.mpart13-4PhoneUl2 {
  width: 336px;
  height: 96px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 32px;
  /* or 200% */
  margin-left: 28px;
  list-style-type: none;
  letter-spacing: 0.15em;
  margin-bottom: 105px;
  margin-top: 88px;
  /* active(bottom) */

  color: #d19258;
}
.mpart13-4mailp2 {
  width: 336px;
  height: 24px;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 0px;
  /* identical to box height, or 150% */
  text-align: left;
  margin-left: 28px;
  /* margin-top: 15px; */
  letter-spacing: 0.15em;

  /* Text */

  color: #233b57;
}
.mpart13-4mailp {
  width: 336px;
  height: 24px;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  text-align: left;
  letter-spacing: 0.15em;
  margin-left: 30px;
  /* Text */

  color: #233b57;
}
.mpart13-4PhoneUl {
  width: 336px;
  height: 72px;
  margin-top: 45px;
  text-align: left;
  list-style-type: none;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  letter-spacing: 0.15em;

  /* Text */

  color: #233b57;
}
.mpart13-0T {
  width: 130px;
  height: 24px;
  margin-top: 15px;
  margin-left: 36px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* _Text */

  color: #233b57;

  transform: rotate(-90deg);
}
.mpart13-0L {
  width: 200px;
  height: 2px;
  margin-top: 150px;
  margin-bottom: 200px;
  /* _Text */

  background: #233b57;
  transform: rotate(-90deg);
}
.mpart13-1Line {
  width: 120px;
  height: 1px;
  margin-top: 108px;
  margin-bottom: 99px;

  background: #b4c0cf;
}
.mpart13T {
  width: 715px;
  height: 96px;

  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  /* or 150% */

  letter-spacing: 0.1em;
  margin-top: 39px;
  margin-bottom: 96px;
  /* Text */

  text-align: left;
  color: #233b57;
}
.mpart13Tp {
  width: 696px;
  height: 80px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 40px;
  /* or 222% */
  margin-top: 210px;
  letter-spacing: 0.1em;
  text-indent: 32px;

  /* Text */

  color: #233b57;
}
/***********part 13 end */
/******part 14 *****/
.part14 {
  display: grid;
  grid-template-columns: 200px 1fr 0.5fr 1fr 0.5fr;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.part14-0 {
  grid-column: 1/2;
  grid-row: 3/3;
}
.part14-1 {
  grid-column: 2/3;
  grid-row: 2/2;
  display: flex;

}
.part14-2 {
  grid-column: 4/5;
  grid-row: 2/2;
    display: flex;
}
.part14-3 {
  grid-column: 2/3;
  grid-row: 3/3;
    display: flex;
}
.part14-4 {
  grid-column: 4/5;
  grid-row: 3/3;
    display: flex;
}
.part14-5 {
  grid-column: 2/3;
  grid-row: 4/4;
    display: flex;
}

.part14-6 {
  grid-column: 4/5;
  grid-row: 4/4;
    display: flex;
}
.part14-8 {
  grid-column: 2/5;
  grid-row: 1/2;
}
.part14Line{
width: 1672px;
height: 1px;
left: 200px;
top: 3600px;
margin-bottom:127px ;
margin-top: 96px;
/* line (darck) */

background: #B4C0CF;
}
.part14h1{
width: 100%;
height: 32px;
left: 176px;
top: 8px;
text-align: left;
font-family: Inter;
font-style: normal;
font-weight: 600;
font-size: 24px;
line-height: 32px;
/* identical to box height, or 133% */

letter-spacing: 0.1em;

/* metalix (ligtt,text) */

color: #36454F;
}
.part14p{
  margin-top: 40px;
  margin-bottom: 112px;
  width: 544px;
height: 96px;
left: 176px;
top: 80px;
text-align: left;
font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 32px;
/* or 200% */

letter-spacing: 0.1em;
text-indent: 24px;

/* metalix (ligtt,text) */

color: #36454F;
}
/******part 14 end */
/****part15 */
.part15 {
  display: grid;
  grid-template-columns: 200px 1fr ;
  grid-auto-rows: minmax(1136, auto);
  background: #F2F6F5;
}
.part15-0{
  grid-column: 1/2;
  grid-row: 1/2;
}

.part15-1{
  grid-column: 2/3;
  grid-row: 1/2;
}
.part15Line{
  width: 384px;
height: 2px;
margin-top: 287px;
    margin-left: -95px;

/* metalix (ligtt,text) */

background: #36454F;
/* line */

box-shadow: inset 1px 0px 0px #36454F;
transform: rotate(-90deg);
}
.part15h1{
  text-align: left;
  margin-top: 144px;
  margin-bottom: 112px;
  margin-left: 150px;
  width: 1152px;
height: 224px;
left: 384px;
top: 4704px;

font-family: Inter;
font-style: normal;
font-weight: 600;
font-size: 32px;
line-height: 56px;
/* or 175% */

letter-spacing: 0.1em;
text-indent: 32px;

/* metalix (ligtt,text) */

color: #36454F;
}
.about-text{
  font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 40px;
/* or 222% */
text-align: start;
letter-spacing: 0.1em;
text-indent: 32px;
margin-top: 10rem;
/* metalix (ligtt,text) */

color: #36454F;
}
.about-line{
  max-width: 392px;
  height: 4px;
  background: rgb(0, 0, 0);
  margin-top: 13rem;
  opacity: 1;
}
.mpart2-3 img, .mpart2-6 img, .mpart2-7 img{
    width: 20%;
    height: auto;
}
.decorative-image-2{
  /* height: auto;
  width: 90%; */
}
.about-first{
  display: flex;
}
.about-second{
  display: flex;
}
.about-second h4{
  margin-top: 3rem;
  margin-right: 2rem;
  font-family: Inter;
font-style: normal;
font-weight: 600;
font-size: 32px;
line-height: 48px;
/* or 150% */
text-align: start;
letter-spacing: 0.05em;

/* metalix (ligtt,text) */

color: #36454F;

}
.about-first h4{
  margin-top: 3rem;
  margin-left: 2rem;
  font-family: Inter;
font-style: normal;
font-weight: 600;
font-size: 32px;
line-height: 48px;
/* or 150% */

letter-spacing: 0.05em;
text-align: start;
/* metalix (ligtt,text) */

color: #36454F;

}
/****part15 end*/
/* iPads (portrait and landscape) ----------- */
@media only screen 
and (min-device-width : 768px) 
and (max-device-width : 1024px) {
  .mpart13T{
    margin-top: 0em;
  }
  .mpart13-4Line{
    margin-top: 3rem;
  }
  .sending-btn{
  width: 340px;
}
  .mpart2-10{
    display: none;
  }
  .part15h1{
    width: 700px !important;
    height: 16em !important;
    font-size: 20px !important;
  }
  .mpart2-1MiniB{
    display: block;
  }
  .mpart1{
   display: grid;
  grid-template-columns: 10vw 1fr 384px;
  grid-auto-rows: minmax(472, auto);
   background: #fbfbfb;  
}
.mpart1-1 {
  grid-column: 2/3;
  grid-row: 1/2;
}
.mpart1Title{
  font-size: 32px;
}
.mpart1p{
  width: 635px;
  height: 180px;
}
/*****part 2 */
.mpart2
{
    display: grid;
  grid-template-columns: 5vw 1fr 5vw;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.mpart2-0 {
 display: none;
}
.mpart2-1 {
  grid-column: 2/2;
  grid-row: 1/2;
  text-align: left;
}
.mpart2-2 {
  grid-column: 2/2;
  grid-row: 2/2;
}
.mpart2-3 {
  grid-column: 2/2;
  grid-row: 3/3;
  margin-top: 32px;
}
.mpart2-4 {
  grid-column: 2/2;
  grid-row: 4/4;
  text-align: left;
  margin-top: 32px;
}
.mpart2-5 {
  grid-column: 2/2;
  grid-row: 5/5;

}
.mpart2-6 {
  grid-column: 2/2;
  grid-row: 6/6;
}
.mpart2-7 {
  grid-column: 2/2;
  grid-row: 7/7;
  margin-top:4rem;
  margin-bottom: 6rem;
}
.mpart2-8 {
  grid-column: 2/2;
  grid-row: 8/8;
  text-align: left;
  margin-top: 32px;
}
.mpart2-9 {
  grid-column: 2/2;
  grid-row: 9/9;

}
.part11-1{
  display: none;
}
.part11Title{
  height: 0px;
  font-size: 30px;
}
.decorative-image-2{
  width: 100%;
  height: 35rem;
}
.part11BlockLine{
  width: 210px !important;
}
.part11Line{
  margin-left: 40px;
}
#fname{
  width: 320px;
}
.mpart2-1p{
  height: 0em;
}
.about-text{
  margin-top: 4rem;
}
.part11-7 , .part11-8, .part11-3{
  display: none !important;
}
.part11{
  grid-template-columns: 40px 1fr !important;
}
.mpart2-11{
  margin-top: 38rem;
}
.mpart2-11{
    grid-column: 2/2;
    grid-row: 5/5;
    margin-bottom: 6rem;
}
/****part 14 */
.part14 {
  display: grid;
  grid-template-columns:5vw 1fr 5vw;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.mpart2-3 .mpart2-1p {
  margin-bottom: 10rem;
}
.about-text-main{
  font-size: 34px !important;
}
.part14-0 {
 display: none;
}
.part14-1 {
  grid-column: 2/2;
  grid-row: 2/2;
  display: flex;

}
.part14-2 {
  grid-column: 2/2;
  grid-row: 3/3;
    display: flex;
}
.part14-3 {
  grid-column: 2/2;
  grid-row: 4/4;
    display: flex;
}
.part14-4 {
  grid-column: 2/2;
  grid-row: 5/5;
    display: flex;
}
.part14-5 {
  grid-column: 2/2;
  grid-row: 6/6;
    display: flex;
}

.part14-6 {
  grid-column: 2/2;
  grid-row: 7/7;
    display: flex;
}
.part14-8 {
  grid-column: 2/2;
  grid-row: 8/8;
}
.part14Line{
  width: 700px;
}
/****part15 */
.part15 {
  display: grid;
  grid-template-columns: 5vw 1fr 5vw ;
  grid-auto-rows: minmax(1136, auto);
  background: #F2F6F5;
}
.part15-0{
  display: none;
}

.part15-1{
  grid-column: 2/2;
  grid-row: 1/2;
}
.part15Line{
  width: 184px !important;
height: 2px;
margin-top: 287px;
margin-left: -70px;

/* metalix (ligtt,text) */

background: #36454F;
/* line */

box-shadow: inset 1px 0px 0px #36454F;
transform: rotate(-90deg);
}
.part15h1{
  text-align: left;
  margin-top: 144px;
  margin-bottom: 112px;
  margin-left: 0px;
  width: 600px;
height: 224px;
left: 384px;
top: 4704px;

font-family: Inter;
font-style: normal;
font-weight: 600;
font-size: 26px;
line-height: 56px;
/* or 175% */

letter-spacing: 0.1em;
text-indent: 32px;

/* metalix (ligtt,text) */

color: #36454F;
}
/**** */
.mpart8Title{
  width: 80vw;
  font-size: 26px;
  height: 10rem;
}
.mpart8mainTitle{
  width:65vw;
  font-size: 26px;
}
/******part13 */
/*****part 13 */
.mpart13 {
  display: grid;
  grid-template-columns: 40px 1fr 5vw;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.mpart13-0 {
  display: none;
}
.mpart13-1 {
  grid-column: 2/2;
  grid-row: 1/1;
}
.mpart13-2 {
  grid-column: 2/2;
  grid-row: 2/2;
}
.mpart13-3 {
  grid-column: 2/2;
  grid-row: 3/3;
}
.mpart13-4 {
  grid-column: 2/2;
  grid-row: 4/4;
}
.mpart13-5 {
  grid-column: 2/2;
  grid-row: 5/5;
}
/*****part12 */
.mpart12 {
  display: grid;
  grid-template-columns: 40px 1fr 5vw;
  grid-auto-rows: minmax(1136, auto);
  background: #36454f;
}
.mpart12-0Line{
  margin-left: 40px;
}
.mpart12-0 {
  grid-column: 2/2;
  grid-row: 1/1;
}
.mpart12-1 {
  grid-column: 2/2;
  grid-row: 2/2;
}
.mpart12-2 {
  display: none;
}
.mpart12-3 {
  grid-column: 2/2;
  grid-row: 3/3;
}
.mpart12-4 {
  grid-column: 2/2;
  grid-row: 4/4;
}
.mpart12-5 {
  grid-column: 2/2;
  grid-row: 5/5;
}
.mpart12-6 {
  grid-column: 2/2;
  grid-row: 6/6;
}
.mpart12-1Line{
  width: 700px;
  margin-top: 0px;
}
#fname[data-v-ed6a348c] {
    width: 292px;
    height: 64px;
    background: #fbfbfb;
    border: 1px solid #fbfbfb;
    box-sizing: border-box;
}
.inputMar{
  margin-left: 120px;
}
.mpart12Infotextarea{
  width: 700px !important;
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.mpart12InfoLine{
  width: 680px !important;
}
.mpart12InfoButton{
  width: 300px;
}
.mpart2-1Line{
  width: 650px;
}
.mpart8HideInfo {
  display: none;
}
.mpart13Tp{
  margin-top: 0px;
}

}

@media (min-width: 1367px) and (max-width: 1440px) {
  .mpart8Title{
    width: 800px;
  }
  .mpart12-3T{
    font-size: 24px;
  }
  .mpart1p{
    height: 150px !important;
  }
  .mpart2-1Line{
    margin-top: 45px;
    width: 100%;
    margin-bottom: 2rem;
  }
  .mpart1{
    grid-template-columns: 200px 1fr 384px;
  }
  .decorative-image-2{
    width:100%;

  }
  .mpart5leftLine{
    margin-left: 3px;
  }
  .mpart2{
    grid-template-columns: 170px 1fr 1fr 1fr 1fr 1fr 0.5fr;
}
  .mpart12InfoButton{
    margin-left: .5rem;
  }
  .mpart12-3{
    grid-column: 1/4;
    grid-row: 2/3;
    margin-left: 40px;
  }
  .mpart12-0Line{
    margin-left: 40px;
  }
  .mpart13-0{
    display: none;
}
.mpart13Tp{
  width: 100%;
}
.mpart13-2 {
    grid-column: 1/4 !important;
    grid-row: 2/2;
    margin-left: 40px;
}
.mpart13-4{
    grid-column: 1/4;
    grid-row: 3/3;
    margin-left: 40px;
}
  .mpart12-6{
    grid-column: 1/4;
    grid-row: 4/6;
    margin-left: 40px;
}
    .mpart12-5{
    grid-column: 1/4;
    grid-row: 3/4;
    margin-left: 40px;
  }
  .part11Line{
    margin-left: 40px;
  }
  .mpart12-2{
    display: none;
  }
  .mpart2-0 {
    grid-column: 1/2;
    grid-row: 1/1;
    margin-top: 15rem !important;
}
  .about-text-main{
    font-size: 40px !important;
    margin-top: 7rem;
  }
  .about-second h4{
    font-size: 30px;
  }
  .mpart2-7 img, .mpart2-6 img, .mpart2-3 img{
    width: 100px;
  }
  .mpart2-1p{
    width: 100%;
  }
   /*****part11 */
  .part11 {
    display: grid;
    grid-template-columns: 40px 1fr 1fr 1fr 1fr 1fr 0.5fr;
    grid-auto-rows: minmax(1136, auto);
    background: #fafafa;
  }
  .part11-1 {
    display: none;
  }
 
}
/* Desktops and laptops  1280-----------@media only screen and (max-width: 1280px) { old */
@media (min-width: 1025px) and (max-width: 1280px) {
   .mpart2-1Line{
     margin-top: 5px;
   }
  .mpart12InfoLine{
    width: 780px;
  }
  .mpart8Title{
    width: 1200px;
  }
  .mpart1p{
    height: 150px;
  }
  .mpart12Infotextarea{
    width: 42.1em !important;
    margin-left: -45px !important;
  }
}




@media only screen 
and (min-device-width : 320px) 
and (max-device-width : 480px) {
/* Styles */
.mpart1p{
  margin-left: 0rem ;
  font-size: 18px !important;
}
 .sending-btn{
    width: 340px !important;
    margin-left: 28px !important;
}
.form-metalix-1{
  width: 340px !important;
  margin-left: 17px;
}
.checking{
  display: none;
}
.mpart2-4{
  padding-top: 0rem;
}
.embedded-al-text{
   margin-right: 10px;
}
.mpart2-11 .about-second img, .mpart2-11 .about-second h4{
  margin-top: 0px !important;
}
.about-second{
  margin-left: 2rem;
}
.about-second img{
  width: 70px;
  height: 70px;
}
.about-second h4{
  font-size: 22px;
  line-height: 35px;
}
.about-text{
  margin-top: 5rem;
  margin-left: 2rem;
  margin-right: 1rem;
}
.about-first{
  margin-left: 2rem;
}
.about-first img{
  height: 70px;
  width: 70px;
}
.about-first h4{
  font-size: 26px;
  line-height: 40px;
}
.mpart2-5{
  padding-top: 0rem;
  padding-bottom: 0rem;
}
.mpart2-1MiniB{
  display: block;
}
.part14Line-1{
  display: none;
}
.embedded-text-three{
  margin-top: 4rem !important;
}
#fname {
    margin-top: 40px;
    width: 300px !important;
    margin-left: 32px !important;
  }
  .inputMar {
    margin-left: 0px !important;
  }
  .fish{
    top: 25%;
    right: 30%;
}
  .mpart1-1Title{
    margin-left: 0;
  }
  .mpart12InfoButton{
    margin-left: 22px;
    margin-bottom: 35px;
    margin-top: 0 !important;
  }
/****part11 *****/
.part11-4, .part11-5, .part11-6, .part11-7,.part11-8{
  margin-left: -1rem;
}
.part11Imargin{
  margin-left: -14px !important;
  width: 100vw;
  height: 400px;
  padding: 0;
}
  .part11 {
    display: grid;
    grid-gap: 1rem !important;
    grid-template-columns: repeat(auto-fit, minmax(2ch, 1fr)) !important;
    /* grid-template-columns:16px 1fr 16px !important;
    grid-auto-rows: minmax(1136, auto); */
    background: #fafafa;
    margin-top: 0px !important;
    padding-left: 30px;
  }
  .part11Date {
    display: none;
  }
  .part11Date2 {
    display: none;
  }
  .partInfoLine {
    width: 64px;
    height: 1px;

    margin-top: 39px;
    margin-left: 16px;
    background: #b4c0cf;
  }
  .part11Title {
    width: 328px !important;
    height: 128px !important;
    margin-left: 0px !important;
    margin-bottom: 40px !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    /* or 133% */
    margin-top: 2rem;
    letter-spacing: 0.1em;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part11BTitle {
    width: 252px;
    height: 72px;
    margin-left: 16px;
    /* top: 6864px; */
    text-overflow: ellipsis;
    overflow: hidden;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    /* or 171% */
    margin-top: 0px !important;
    letter-spacing: 0.1em;
    text-decoration-line: underline;

    /* _Text */

    color: #233b57;
  }
  .part11-8 .part11BTitle2{
    height: 150px !important;
  }
  .part11BTitle2 {
    width: 252px;
    height: 50px;
    /* top: 6864px; */
    text-overflow: ellipsis;
    overflow: hidden;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    /* or 171% */
    margin-bottom: 0px !important;
    letter-spacing: 0.1em;
    text-decoration-line: underline;
    margin-left: 16px;
    /* _Text */

    color: #233b57;
  }
  .part115Img img {
    width: 100vw;
    height: 400px;
  }
  .part11Imargin {
    margin-top: 0px;
  }
  .part11B {
    width: 310px;
    margin-left: -2rem;
  }
  .part11BP {
    width: 328px;
    height: 176px;

    margin-top: 24px;
    margin-left: 16px;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */

    letter-spacing: 0.1em;
    text-indent: 24px;

    /* _Text */

    color: #233b57;
  }
  .part11Line {
    display: none;
  }
  .part11Info {
    /* width: 63px;
    height: 16px;
    margin-left: 24px;
    margin-top: 32px;
    margin-bottom: 32px;
    transform: none;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 2px;
    color: #36454f; */
    display: none;
  }
  .part11InfoLine {
    display: none;
  }
  .part11BlockLine {
    width: 152px;
    height: 1px;
    margin-left: 16px;
    margin-top: 1rem;
    background: #b4c0cf;
    opacity: 0.32;
  }
  .part11BlockLine2 {
    width: 152px;
    height: 1px;
    margin-left: 16px;

    background: #b4c0cf;
    opacity: 0.32;
  }
  .part11-0 {
    display: none;
  }
  .part11-1 {
    grid-column: 2/3 !important;
    grid-row: 1/2 !important;
    display: flex;
  }
  .part11-2 {
    grid-column: 2/3 !important;
    grid-row: 2/2 !important;
  }
  .part11-3 {
    grid-column: 2/3 !important;
    grid-row: 3/3 !important;
  }
  .part11-4 {
    grid-column: 2/3 !important;
    grid-row: 4/4 !important;
  }

  .part11-5 {
    grid-column: 2/3 !important;
    grid-row: 5/5 !important;
  }
  .part11-6 {
    grid-column: 2/3 !important;
    grid-row: 6/6 !important;
  }
  .part11-7 {
    grid-column: 2/3 !important;
    grid-row: 7/7 !important;
  }

  .part11-8 {
    grid-column: 2/3 !important;
    grid-row: 8/8 !important;
  }
.mpart12 {
    display: grid;
    grid-template-columns: 1fr !important;
    grid-auto-rows: minmax(1136, auto);
    background: #36454f;
  }
  .mpart12-0 {
    grid-column: 1/2 !important;
    grid-row: 1/2 !important;
  }
  .mpart12-1 {
    grid-column: 1/2 !important;
    grid-row: 2/2 !important;
  }
  .mpart12-2 {
    grid-column: 1/2 !important;
    grid-row: 3/3 !important;
    display: flex !important;
  }
  .mpart12-3 {
    grid-column: 1/2 !important;
    grid-row: 4/4 !important;
  }
  .mpart12-4 {
    grid-column: 1/2 !important;
    grid-row: 5/5 !important;
  }
  .mpart12-5 {
    grid-column: 1/2 !important;
    grid-row: 6/6 !important;
  }
  .mpart12-6 {
    grid-column: 1/2 !important;
    grid-row: 7/7 !important;
  }
.mpart12{
  margin-top: 0 !important;
  grid-template-columns: 25px 1fr 1fr 1fr 1fr 1fr !important;
}
.mpart12-4{
  margin-top: 8rem;
}
.mpart12-1Line {
    width: 300px !important;
    height: 2px;
    margin-top: 0px !important;
    margin-bottom: 39px !important;
    background: #fbfbfb;
    opacity: 0.16;
}
.mpart12InfoMust {
    width: 380px !important;
    height: 24px;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    margin-top: 40px !important;
    margin-bottom: 70px !important;
    margin-left: 25px !important;
    letter-spacing: 0.1em;
    color: #fbfbfb;
}
.mpart12InfoButton {
    width: 300px !important;
    height: 80px ;
    background: #cfd3d6;
    box-shadow: 0px 4px 32px #575d65;
    margin-left: 32px;
   
    margin-top: 140px;
}
#mpart12Check{
  margin-left: 20px !important;
}

.mpart12-3T{
  margin-left: 25px;
}
.mpart12-0Line {
    
    margin-top: 70px !important;
    margin-bottom: 70px !important;
   
}
.mpart13T {
    width: 300px !important;
    font-size: 20px !important;
   margin-left: 25px;
   line-height: 40px !important;
   padding-top: 40px;
}
.mpart12Tp, .mpart12Tp2 {
    width: 300px !important;
    margin-left: 25px;
}
.mpart13{
  display: block !important;
}
.mpart13-4{
  margin-left: 25px;
}
.mpart13-4Line, .part14Line, .mpart2-1Line{
  display: none;
}
.mpart13Tp{
  margin-left: 25px;
  width: 350px !important;
  margin-right: 140px !important;
}
.mpart13-4PhoneUl{
  margin-top: 20px !important;
}
.mpart13-0{
  display: none;
}
.mpart13-4PhoneUl2{
  margin-left: 12px;
  margin-bottom: 45px !important;
  margin-top: 28px !important;
}
.mpart12TitleLine{
  width: 300px;
}
.mpart12Infotextarea{
  width: 296px !important;
  margin-left: 35px !important;
}
.mpart13T{
  margin-top: 0;
}
.mpart13Tp{
  margin-top: 10px;
}
.about-part{
  margin-right: .5rem;
}
.mpart13-4Address, .mpart13-4PhoneUl{
  margin-left: -12px;
}
.mpart13-4mailp{
  margin-left: 20px;
}
.part14{
  padding-top: 50px;
}
.mpart2-3{
  margin-top: 0px !important;
}
.mpart12Margin{
  display: none !important;
}
.mpart12InfoLine{
  display: none;
}
#fname{
  width: 300px !important;
  /* margin-left: 25px !important; */
}
.part3[data-v-8dc7cce2] {
    display: grid;
    grid-gap: 1rem !important;
    grid-template-columns: repeat(auto-fit, minmax(2ch, 1fr)) !important;
    grid-template-columns: 1fr !important;
    grid-auto-rows: minmax(80px, auto);
}
.decorative-underfooter{
  margin-top: 20px !important;
}
.mt-5 {
    margin-top: 0rem!important;
}
.mpart12-3T {
    width: 300px !important;
    height: 120px !important;
    margin-top: 0;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 26px !important;
    line-height: 48px;
    letter-spacing: 0.1em;
    color: #fbfbfb;
}
.mpart1{
  grid-template-columns: 25px 1fr 384px !important;
}
.mpart12-2Info, .mpart12-2InfoLine{
  display: none;
}
.part14Line{
  width: 400px !important;
}
.part14{
  grid-template-columns: 25px 1fr 0.5fr 1fr 0.5fr !important;
  display: block !important;
}
.part14-0{
  display: none;
}
.part14p {
    margin-top: 20px !important;
    margin-bottom: 112px;
    width: 260px !important;
    height: 106px !important;
    left: 176px;
    top: 80px;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 32px;
    letter-spacing: 0.1em;
    text-indent: 24px;
    color: #36454F;
}
.miniImgClass {
    width: 80px !important;
    height: 80px !important;
    margin-right: 30px !important;
    margin-left: 25px !important;
}
.part14h1 {
    width: 260px !important;
    height: 42px !important;
    left: 156px !important;
    top: 8px;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 18px !important;
    line-height: 32px !important;
    letter-spacing: 0.1em;
    color: #36454F;
}
.decorative-image-main{
  height: 50px !important;
  width: 50px !important;
}
.mpart2-1Line{
  width: 100% !important;
}
.mpart1Title {
    height: 88px;
    font-family: Inter;
    font-style: normal;
    font-weight: bold;
    font-size: 26px !important;
    line-height: 40px !important;
    margin-left: 24px !important;
    letter-spacing: 0.015em;
    text-transform: uppercase;
    color: #36454F;
    width: 200px;
}

.mpartInfoT{
  display: none;
}
.mpart2{
  display: block !important;
}
.decorative-image-2{
  width: 100%;
  height: auto;
}
.mpart13-4PhoneUl2{
  width: 300px;
}
.mpart2-1p{
    width: 95% !important;
    height: 0px !important;
    padding-top: 10px !important;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 18px !important;
    line-height: 38px !important;
    letter-spacing: 0.1em;
    text-indent: 32px;
    color: #36454F;
    padding-left: 2rem;
    padding-right: 2rem;
        margin-bottom: 0rem !important;
        padding-top: 15rem !important;
;
}
.about_text{
  padding-top: 1rem !important;
  padding-bottom: 18rem;
}
.mpart2-0{
  display: none;  
}
.decorative-section-text{
  height: 330px !important;
}
.part15{
  display: none;
}
.mpart8mainTitle{
  font-size: 16px;
  margin-left: 20px;
  width: 320px;
}
.mpart8Title {
    width: 350px !important;

    height:156px;
    margin-bottom: 104px;
    margin-left: 40px !important;
    margin-right: 32px;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 20px !important;
    line-height: 48px;
    letter-spacing: 0.1em;
    text-indent: 32px;
    color: #36454f;
}
.embedded-text-first{
  margin-top: -150px !important;
  height: 100px;
}
.embedded-text{
  font-size: 22px;
  margin-left: 1rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.embedded-text-first-1{
  margin-top: 150px !important;
  height: 170px;
}
.mpart8Title{
  margin-left: 20px !important;
  width: 300px !important;
  margin-bottom: 11rem;
}
.part14p{
  width: 230px !important;
}
.mpart5leftLine-1{
  display: none;
}
.miniImgClass{
  width: 70px !important;
  height: 70px !important;
  margin-left: 15px !important;
}
.carouselMain{
  display: block;
  padding: 5vh 5vw;
}
.part8mainTitle{
  font-size: 22px;
  line-height: 40px;
  margin-top: 1rem;
}
.part8mainTitlep{
  font-size: 18px;
  width: 90%;
}
.home-icon{
  margin-left: -4.5rem !important;
}
.embedded-bgg, .embedded-bg{
  margin-left: 1rem;
  width: 340px;
  font-size: 14px;
}
.mpart2-1MiniB{
  display: none;
}





}
/* iPads (portrait) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  /* Styles **/
  .mpart12Infotextarea{
    width: 682px !important;
  }
}
@media (min-width: 1367px) and (max-width: 1440px) {
  .mpart12Infotextarea{
  background: white;
  /* _Light */
  margin-top: 48px;
  margin-left: 0px !important;
  margin-bottom: 46px;
  width: 830px !important;
  height: 80px;
  border: 1px solid #fbfbfb;
  box-sizing: border-box;
  resize: none;
}
}
</style>